import React from 'react';

import { addImageSuffix } from '@utils/Util';

export const CostGettingItem = ({ product, products, index, onChange }) => {
	//console.log('CostGettingItem', product);
	let flag = 1;

	const onChangeQuantity = async (e) => {
		let { name, value } = e.target;
		let [i, j, k] = name.split('_');
		//console.log('after splitting', i, j, k);
		let tempProducts = [...products];
		let item = { ...tempProducts[i] };
		let colorObj = [...item.colorWiseSizeQuantityPairList];
		let pairs = [...colorObj[j].sizeQuantityPairList];
		pairs[k] = {
			code: pairs[k].code,
			quantity: value
		};
		item.colorWiseSizeQuantityPairList[j].sizeQuantityPairList = pairs;
		tempProducts[i] = item;
		onChange(tempProducts);
	};

	const onChangeField = (e) => {
		let { name, value } = e.target;
		let temp = { ...product };
		temp[name] = value;
		let tempProducts = [...products];
		tempProducts[index] = temp;
		onChange(tempProducts);
	};

	return (
		<div className="quote-list mb-3">
			<div className="d-flex align-items-start">
				<div className="product-img-side">
					<a href="#">
						{product.documentResponseList && product.documentResponseList.length > 0 ? (
							product.documentResponseList.map((doc, i) => {
								if (doc.docType == 'PRODUCT_DESIGN' && flag) {
									flag = 0;
									return (
										<img
											key={i}
											src={addImageSuffix(doc.docUrl, '_xthumbnail')}
											alt="designer"
											className="radius-3"
										/>
									);
								}
								if (product.documentResponseList.length == i + 1 && flag) {
									return (
										<img
											key={i}
											src={product.documentResponseList[0].docUrl}
											alt="designer"
											className="radius-3"
										/>
									);
								}
							})
						) : (
							<img
								src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
								alt="designer"
								className="radius-3"
							/>
						)}
					</a>
				</div>
				<div className="ml-4 flex-1">
					<a href="#" className="text-black font-weight-bold m-0  font-24 ellipse-1-line">
						{product.name}
					</a>
					<div className="quote-info d-flex">
						<div className="info-right w-100 ml-0">
							<div className="add-quote-list d-flex features flex-column flex-sm-row justify-content-between pr-0 w-100">
								<div className="info-item mr-3">
									<label className="font-14 text-muted">Design category</label>
									<h5 className="font-16 color-333">
										{product.productType}, {product.productGroup}
									</h5>
								</div>
								<div className="info-item mr-3">
									<label className="font-14 text-muted">Fabric details</label>
									<h5 className="font-16 color-333">
										{product.fabricDetails ? product.fabricDetails : 'N/A'}
									</h5>
								</div>
								<div className="info-item target-price-container">
									<label className="font-14 text-muted">Target price</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type Amount"
										className="border-0 bg-gray-light target-price"
										name="targetPrice"
										value={product && product.targetPrice ? product.targetPrice : ''}
										onChange={onChangeField}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="ml-auto">
				<div className="size-n-color d-flex  flex-column">
					<div className="sizes d-flex  align-items-center justify-content-end mb-0">
						<div className="size">
							<label className="text-center">&nbsp;</label>
						</div>
						{product.colorWiseSizeQuantityPairList &&
						product.colorWiseSizeQuantityPairList.length ? (
							product.colorWiseSizeQuantityPairList[0].sizeQuantityPairList.map((pair, j) => {
								return (
									<div className="size" key={`color_wise_size_${j}`}>
										<label className="text-center">{pair.code}</label>
									</div>
								);
							})
						) : (
							<></>
						)}
						<div className="size total">
							<label className="text-right">Total</label>
						</div>
					</div>
					{product.colorWiseSizeQuantityPairList.map((obj, i) => {
						let total = 0;
						return (
							<div
								className="sizes d-flex  align-items-center justify-content-end"
								key={`${index}_${i}`}
							>
								<div className="size">
									<div className="product-color" style={{ background: obj.hexCode }}></div>
								</div>
								{obj.sizeQuantityPairList.map((pair, j) => {
									total += parseInt(pair.quantity) ? parseInt(pair.quantity) : 0;
									return (
										<div className="size" key={`${index}_${i}_${j}`}>
											<input
												type="text"
												autoComplete="off"
												placeholder="00"
												id={`${index}_${i}_${j}`}
												name={`${index}_${i}_${j}`}
												value={pair.quantity ? pair.quantity : ''}
												onChange={onChangeQuantity}
												className="bg-gray-light"
											/>
										</div>
									);
								})}
								<div className="size total">
									<input
										type="text"
										autoComplete="off"
										placeholder="00"
										className="bg-gray-light"
										value={total}
										disabled
									/>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
